import { useCallback, useEffect, useState } from "react";

const WARNING_AUTOHIDE_DELAY = 3000;

export const useWarnings = () => {
  const [warning, setWarning] = useState("");

  const showWarning = useCallback((warning) => {
    setWarning(warning);
  }, []);

  const hideWarning = useCallback(() => {
    setWarning("");
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (warning) {
        setWarning("");
      }
    }, WARNING_AUTOHIDE_DELAY);

    return () => clearTimeout(timeout);
  }, [warning]);

  return {
    warning,
    showWarning,
    hideWarning,
  };
};
